var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#002E40"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 31.9998C8.60008 31.9998 7.9723 31.7387 7.45008 31.2165C6.92786 30.6943 6.66675 30.0665 6.66675 29.3332V14.6665C6.66675 13.9332 6.92786 13.3054 7.45008 12.7832C7.9723 12.2609 8.60008 11.9998 9.33341 11.9998H14.6667V9.33317C14.6667 8.59984 14.9279 7.97206 15.4501 7.44984C15.9723 6.92762 16.6001 6.6665 17.3334 6.6665H22.6667C23.4001 6.6665 24.0279 6.92762 24.5501 7.44984C25.0723 7.97206 25.3334 8.59984 25.3334 9.33317V11.9998H30.6667C31.4001 11.9998 32.0279 12.2609 32.5501 12.7832C33.0723 13.3054 33.3334 13.9332 33.3334 14.6665V29.3332C33.3334 30.0665 33.0723 30.6943 32.5501 31.2165C32.0279 31.7387 31.4001 31.9998 30.6667 31.9998H9.33341ZM9.33341 29.3332H30.6667V14.6665H9.33341V29.3332ZM17.3334 11.9998H22.6667V9.33317H17.3334V11.9998Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProject);
export default __webpack_public_path__ + "static/media/ActiveProject.77e47066f872faecc7464d2e443e4c2b.svg";
export { ForwardRef as ReactComponent };